import { css } from "@emotion/css";
import { Text } from "components/common";
import { MultiplayerLogo } from "components/icons";
import React from "react";

export const Footer: React.FC = () => (
  <div className={css`
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 24px;
        padding-right: 24px; 
        padding-left: 0px;
        border-top: 1px solid #2E2D33;
        margin-top: 24px;
        position: absolute;
        bottom: 0;
        left: 0;

        `}>
        <MultiplayerLogo style={{height: '30px'}} />

        <Text.Body style={{ fontSize: "19px", zIndex: 2 }}>
          multiplayer.work/wrapped
        </Text.Body>
       </div>
)